export default ["xs", "s", "m", "l"];
